declare global {
    interface Window {
      dataLayer: any[];
    }
  }
  
  const GTM_SCRIPT_ID = "gtm-script";
  const GTM_NOSCRIPT_ID = "gtm-noscript";
  

  export function initGTM(
    gtmId: string,
    options?: {
      dataLayerName?: string;            // default "dataLayer"
      addNoScriptToBody?: boolean;       // default true
      noScriptPosition?: "top" | "bottom"; // default "top"
    }
  ) {
    if (!gtmId) return;
  
    const {
      dataLayerName = "dataLayer",
      addNoScriptToBody = true,
      noScriptPosition = "top",
    } = options || {};
  
    (window as any)[dataLayerName] = (window as any)[dataLayerName] || [];
    (window as any)[dataLayerName].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
  
    
    if (!document.getElementById(GTM_SCRIPT_ID)) {
      const firstScript = document.getElementsByTagName("script")[0];
      const script = document.createElement("script");
      script.id = GTM_SCRIPT_ID;
      script.async = true;
  
      const dl =
        dataLayerName !== "dataLayer"
          ? `&l=${encodeURIComponent(dataLayerName)}`
          : "";
  
      script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
        gtmId
      )}${dl}`;
  
      // Insert before the first <script> like GTM snippet does
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        // Fallback: append to head
        document.head.appendChild(script);
      }
    }
  
    // -------------------------
    // Add noscript iframe to <body> (requested)
    // -------------------------
    if (addNoScriptToBody) {
      injectNoScriptIframe(gtmId, noScriptPosition);
    }
  }
  
  function injectNoScriptIframe(gtmId: string, position: "top" | "bottom") {
    if (document.getElementById(GTM_NOSCRIPT_ID)) return;
  
    const noscript = document.createElement("noscript");
    noscript.id = GTM_NOSCRIPT_ID;
  
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(
      gtmId
    )}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
  
    noscript.appendChild(iframe);
  
    const append = () => {
      if (!document.body) return;
  
      if (position === "top") {
        document.body.insertBefore(noscript, document.body.firstChild);
      } else {
        document.body.appendChild(noscript);
      }
    };
  
    // Ensure body exists
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", append, { once: true });
    } else {
      append();
    }
  }
  